// extracted by mini-css-extract-plugin
module.exports = {"circularButton":"CircularButton_circularButton__3iMmH","isFloating":"CircularButton_isFloating__oxy19","borderless":"CircularButton_borderless__1WJx_"};